const images = [
    'Coworking_1.jpg',
    'Coworking_2.jpg',
    'Coworking_3.jpg',
    'Coworking_4.jpg',
    'Coworking_5.jpg',
    'Groupwork_1.jpg',
    'Groupwork_2.jpg',
    'Groupwork_3.jpg',
    'Groupwork_4.jpg',
    'Groupwork_5.jpg',
    'Individual_1.jpg',
    'Individual_2.jpg',
    'Individual_3.jpg',
    'Individual_4.jpg',
    'Individual_5.jpg',
    'Outdoor_1.jpg',
    'Outdoor_2.jpg',
    'Outdoor_3.jpg',
    'Outdoor_4.jpg',
    'Outdoor_5.jpg',
];

const moodBoardData = images.map((im, i) => {
  const [key] = im.split('.');
    return {
        "key": key,
        "img": `img/carousel-images/${im}`
    };
});
moodBoardData.sort(() => Math.random() - 0.5);

export default moodBoardData;
